import type { SectionType } from "@entities/model/model";

/** Model configuration sections, in the order they appear as chips. */
export const MODEL_SECTIONS: SectionType[] = [
	"fields",
	"stop_factors",
	"macro_variables",
	"markers",
	"risk_thresholds",
	"approval_threshold",
	"rec_system",
	"score_mapping",
	"repeat_limits",
	"pending_approval",
];

export const isModelSection = (value: unknown): value is SectionType =>
	MODEL_SECTIONS.includes(value as SectionType);

/** Per the product spec agreed on the pre-launch access daily: `model_settings`
 * (root-equivalent) unlocks every section, while `scoring_settings` alone only
 * unlocks Macroparameters, Approval Threshold (the plain threshold value —
 * not the Risk Thresholds visual bands), and Recommendation System. */
export const SCORING_SETTINGS_SECTIONS: SectionType[] = [
	"macro_variables",
	"approval_threshold",
	"rec_system",
	// A scoring_settings role can edit sections whose saves get queued, so it
	// needs somewhere to see its own submissions waiting and withdraw them.
	// Deciding on a change is the narrower right, checked per card.
	"pending_approval",
];

export const resolveAvailableModelSections = (
	hasModelSettings: boolean,
	hasScoringSettings: boolean,
): SectionType[] => {
	if (hasModelSettings) return MODEL_SECTIONS;
	if (hasScoringSettings) return SCORING_SETTINGS_SECTIONS;
	return [];
};

export type FieldTypeFilter = "all" | "macro" | "variables" | "synthetic";

export const FIELD_TYPE_FILTERS: FieldTypeFilter[] = [
	"all",
	"macro",
	"variables",
	"synthetic",
];

export const isFieldTypeFilter = (value: unknown): value is FieldTypeFilter =>
	FIELD_TYPE_FILTERS.includes(value as FieldTypeFilter);
